// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"b6cce1c5d8b6128f","915":"8699a014ab4d4e37","983":"562862cc3f1dfc1a"}[chunkId] + ".js";
};